import { SVGProps } from 'react';

function TableSentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.4 19.925C4.06667 20.0583 3.75 20.0291 3.45 19.8375C3.15 19.6458 3 19.3666 3 19V14.5L11 12.5L3 10.5V5.99997C3 5.6333 3.15 5.35414 3.45 5.16247C3.75 4.9708 4.06667 4.94164 4.4 5.07497L19.8 11.575C20.2167 11.7583 20.425 12.0666 20.425 12.5C20.425 12.9333 20.2167 13.2416 19.8 13.425L4.4 19.925Z" fill="#868991" />
    </svg>
  );
}

export default TableSentIcon;
